import { API_BASE_URL } from "./api";

export async function openAttachmentView(
  attachmentId: string,
  _fileName: string,
  contentType: string,
  token: string | null,
): Promise<void> {
  const authToken = token ?? localStorage.getItem("authToken");
  const res = await fetch(`${API_BASE_URL}/attachments/${attachmentId}/download?inline=1`, {
    headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
  });
  if (!res.ok) throw new Error("Could not open attachment.");

  const blob = await res.blob();
  const type = contentType || blob.type || "application/octet-stream";
  const viewBlob = blob.type ? blob : new Blob([blob], { type });
  const url = URL.createObjectURL(viewBlob);

  if (type.startsWith("text/html")) {
    const html = await viewBlob.text();
    const w = window.open("", "_blank");
    if (w) {
      w.document.write(html);
      w.document.close();
      URL.revokeObjectURL(url);
      return;
    }
  }

  window.open(url, "_blank", "noopener,noreferrer");
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

export async function openHtmlDocument(
  path: string,
  token: string | null,
): Promise<void> {
  const authToken = token ?? localStorage.getItem("authToken");
  const res = await fetch(`${API_BASE_URL}${path}`, {
    headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
  });
  if (!res.ok) throw new Error("Could not open document.");
  const html = await res.text();
  const w = window.open("", "_blank");
  if (w) {
    w.document.write(html);
    w.document.close();
  }
}
